<template>
	<div id="app">
		<header class="container-fluid p-0 mb-5">
			<nav class="navbar navbar-expand-md navbar-light bg-light">
				<a href="http://www.mybigyellowbus.ca" class="navbar-brand mr-5" target="_blank"><img :src="retina('/images/logo.png')" style="width: 518px; height: 50px;" class="mw-100 h-auto" /></a>
				<div id="google_translate_element"></div>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>

				<div class="collapse navbar-collapse flex-row-reverse" id="navbarSupportedContent" v-if="logged_in">
					<ul class="navbar-nav">
						<li class="nav-item">
							<em class="fas fa-2x loading mr-3"></em>
						</li>
						<li class="nav-item" v-if="user?.form_registration">
							<router-link to="/admin" class="nav-link"><em class="fas fa-bus-alt"></em> Registration</router-link>
						</li>
						<li class="nav-item" v-if="user?.form_ss_legacy">
							<router-link to="/admin/registration-secondary-sibling-legacy" class="nav-link"><em class="fas fa-bus-alt"></em> Registration SS Legacy</router-link>
						</li>
						<li class="nav-item" v-if="user?.form_vacant_seat">
							<router-link to="/admin/vacant-seat" class="nav-link"><em class="fas fa-bus-alt"></em> Vacant Seat</router-link>
						</li>
						<li class="nav-item" v-if="user?.form_specialized_transport">
							<router-link to="/admin/specialized-transport" class="nav-link"><em class="fas fa-bus-alt"></em> Specialized Transport</router-link>
						</li>
						<li class="nav-item" v-if="user?.form_choice_of_school">
							<router-link to="/admin/choice-of-school" class="nav-link"><em class="fas fa-bus-alt"></em> Choice Of School</router-link>
						</li>
						<li class="nav-item" v-if="user?.admin">
							<router-link to="/config" class="nav-link"><em class="fas fa-cogs"></em> Config</router-link>
						</li>
						<li class="nav-item" v-if="user?.admin">
							<router-link to="/users" class="nav-link"><em class="fas fa-users"></em> Users</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/account" class="nav-link"><em class="fas fa-user-tie"></em> My Account</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/logout" class="nav-link"><em class="fas fa-wind fa-flip-horizontal"></em><em class="fas fa-car-side"></em> Logout</router-link>
						</li>
					</ul>
				</div>
			</nav>
		</header>

		<div class="container mb-5"><router-view :session_id="session_id" :logged_in="logged_in" :current_user="user" @setLogin="setLogin" @setSessionID="setSessionID" /></div>

		<footer class="container-fluid p-0 mb-3">
			<hr>
			<nav>
				<ul class="nav d-flex justify-content-center">
					<li class="nav-item">
						<router-link to="/admin" class="nav-link"><em class="fas fa-info-circle"></em> {{app_name}}</router-link>
					</li>
					<li class="nav-item" v-if="logged_in && user?.form_registration">
						<router-link to="/admin" class="nav-link"><em class="fas fa-bus-alt"></em> Registration</router-link>
					</li>
					<li class="nav-item" v-if="logged_in && user?.form_ss_legacy">
						<router-link to="/admin/registration-secondary-sibling-legacy" class="nav-link"><em class="fas fa-bus-alt"></em> Registration SS Legacy</router-link>
					</li>
					<li class="nav-item" v-if="logged_in && user?.form_vacant_seat">
						<router-link to="/admin/vacant-seat" class="nav-link"><em class="fas fa-bus-alt"></em> Vacant Seat</router-link>
					</li>
					<li class="nav-item" v-if="logged_in && user?.form_specialized_transport">
						<router-link to="/admin/specialized-transport" class="nav-link"><em class="fas fa-bus-alt"></em> Specialized Transport</router-link>
					</li>
					<li class="nav-item" v-if="logged_in && user?.form_choice_of_school">
						<router-link to="/admin/choice-of-school" class="nav-link"><em class="fas fa-bus-alt"></em> Choice Of School</router-link>
					</li>
					<li class="nav-item" v-if="logged_in && user?.admin">
						<router-link to="/config" class="nav-link"><em class="fas fa-cogs"></em> Config</router-link>
					</li>
					<li class="nav-item" v-if="logged_in && user?.admin">
						<router-link to="/users" class="nav-link"><em class="fas fa-users"></em> Users</router-link>
					</li>
					<li class="nav-item" v-if="logged_in">
						<router-link to="/account" class="nav-link"><em class="fas fa-user-tie"></em> My Account</router-link>
					</li>
					<li class="nav-item" v-if="logged_in">
						<router-link to="/logout" class="nav-link"><em class="fas fa-wind fa-flip-horizontal"></em><em class="fas fa-car-side"></em> Logout</router-link>
					</li>
				</ul>
			</nav>
		</footer>
	</div>
</template>


<script>
	export default
	{
		name: 'App',
		data() {
			return {
				logged_in: (localStorage.getItem("session_id") != ""),
				session_id: localStorage.getItem("session_id"),
				user: {user_id: null, roles: []}
			}
		},
		methods: {
			checkSession: function()
			{
				var vm = this;

				if(vm.$route.path == "/" || vm.$route.path == "/login" || vm.$route.path == "/registration" || vm.$route.path == "/vacant-seat" || vm.$route.path == "/specialized-transport" || vm.$route.path == "/choice-of-school" || vm.$route.path == "/registration-secondary-sibling-legacy")
				{
					return;
				}

				if(!this.logged_in)
				{
					vm.setLogin(false);
					vm.setSessionID("");

					if(vm.$route.path != "/login")
					{
						vm.$router.push("/login");
					}
				}
				else
				{
					vm.CORS("GET", "/registration/authenticate", "", function(data)
					{
						vm.user = data.user;
					},
					function()
					{
						vm.setLogin(false);
						vm.setSessionID("");

						if(vm.$route.path != "/login")
						{
							vm.$router.push("/login");
						}
					});
				}
			},
			setLogin: function(value, user)
			{
				this.logged_in = value;
				this.user = user;
			},
			setSessionID: function(value)
			{
				this.session_id = value;
				localStorage.setItem("session_id", value);
			}
		},
		mounted: function()
		{
			var vm = this;

			document.getElementsByTagName("title")[0].innerHTML = vm.app_name + " Portal";

			vm.checkSession();

			setInterval(function()
			{
				vm.checkSession();
			}, 60000);
		},
		watch:
		{
			'$route' () {
				this.checkSession();
			}
		}
	}
</script>

<style>
#app
{
	font-family: Avenir, Helvetica, Arial, sans-serif;
}
footer a
{
	color: inherit;
}
.fa-bus,
.fa-bus-alt
{
	color: rgb(255, 187, 68);
}
</style>
